import { useEffect } from "react";
import { SEARCH_TITLE, BUSINESS_SCHEMA } from "@/data/search";

const SITE_URL = "https://sellingsunsets.co.in";
const DEFAULT_IMAGE =
  "https://images.unsplash.com/photo-1767286669935-e466c9ebb881?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * useSeo — sets document title, meta, canonical, OG/Twitter + optional JSON-LD.
 */
export function useSeo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd = null,
} = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} — Selling Sunsets` : SEARCH_TITLE;
    const canonical = `${SITE_URL}${path}`;
    document.title = fullTitle;

    upsertMeta("name", "description", description);
    upsertLink("canonical", canonical);

    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    const scriptId = "ss-jsonld";
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = scriptId;
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, image, type, JSON.stringify(jsonLd)]);
}

export const ORG_JSONLD = BUSINESS_SCHEMA;

export { SITE_URL };

